/* global ChiliPiper */
import domReady from '@wordpress/dom-ready';

function initForms() {
	if (!window?.esForms) {
		return;
	}

	const cpForm = document.querySelectorAll('.es-block-forms.chili-piper form');

	cpForm.forEach((form) => {
		form.addEventListener('esFormsAfterFormSubmitSuccess', () => {
			function createChiliPiperQueueHandler(queueType) {
				return function () {
					ChiliPiper[queueType].queue = (ChiliPiper[queueType].queue || []).concat([arguments]);
				};
			}

			window.ChiliPiper =
				window.ChiliPiper ||
				'submit scheduling showCalendar submit widget bookMeeting'.split(' ').reduce((previous, current) => {
					previous[current] = createChiliPiperQueueHandler(current);

					return previous;
				}, {});

			ChiliPiper.submit('productive-io', 'book-a-demo', {
				title: 'Thanks! What time works best for a quick call?',
			});
		});
	});
}

domReady(() => {
	const cpForm = document.querySelector('.es-block-forms.chili-piper form');

	if (cpForm) {
		initForms();
	}
});
